import { render, staticRenderFns } from "./ForceChangePassword.vue?vue&type=template&id=052ec4a7&scoped=true&"
import script from "./ForceChangePassword.vue?vue&type=script&lang=js&"
export * from "./ForceChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ForceChangePassword.vue?vue&type=style&index=0&id=052ec4a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052ec4a7",
  null
  
)

export default component.exports